import { render, staticRenderFns } from "./Zixi.vue?vue&type=template&id=77ff8a4c&scoped=true&"
import script from "./Zixi.vue?vue&type=script&lang=ts&"
export * from "./Zixi.vue?vue&type=script&lang=ts&"
import style0 from "./Zixi.vue?vue&type=style&index=0&id=77ff8a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff8a4c",
  null
  
)

export default component.exports